import React, { FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import TopImage from '../../assets/images/topImage.png'
import SwipeCard from '../../assets/images/swipeCard.png'
import styles from './TopPageContents.module.scss'
import { CardEntity } from '../../ducks/cards/types'
import { initialStateType as ActressInitialStateType } from '../../ducks/actresses/reducers'

interface PropsType {
  swipeCard(): void
  addModal(card: CardEntity): void
  resetModal(): void
  cards: CardEntity[]
  modals: CardEntity[]
  actresses: ActressInitialStateType
}

const TopPageContents: FC<PropsType> = () => {

  return (
    <div className={ styles.mainContents }>
      <div className={ styles.heroImageContent }>
        <img src={ TopImage } />
      </div>
      <div className={ styles.aboutSection }>
        <div className={ styles.content }>
          <div className={ styles.contentTitle }>
            AVキャッチャーの使い方
          </div>
          <div className={ styles.contentBody }>
            <div className={ styles.firstLine }>
              自分の好みを入力し、マッチする女優を検索
            </div>
            <div className={ styles.secondLine }>
              <div className={ styles.text }>
                気になる女優を<span className={ styles.highLight }>スワイプ</span>し、<br />
                出演作品が<span className={ styles.highLight }>簡単に見つかる！</span>
              </div>
              <div className={ styles.sampleCard }>
                <img src={ SwipeCard } />
              </div>
            </div>
          </div>
          <div className={ styles.contentBottom }>
            <Link to="/search">
              <div className={ styles.searchButton }>
                女優を探す
              </div>
            </Link>
            <div className={ styles.attentionText }>
              これより先は成人向けコンテンツです<br />
              18際以上の方のみ利用ください
            </div>
          </div>
        </div>
      </div>
      <div className={ styles.newlySection }>
        <div className={ styles.sectionTitle }>
          女優ランキング
        </div>
        <div className={ styles.sectionSubTitle }>
          FANZAより、ランキング形式で女優を紹介！
        </div>
        <div className={ styles.sectionBody }>
          <Link to="/result">
            <div className={ styles.rankingButton }>
              今月のランキングを見る
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default TopPageContents